var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 256 256",
    id: "Flat",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208,36H180V24a4,4,0,0,0-8,0V36H84V24a4,4,0,0,0-8,0V36H48A12.01343,12.01343,0,0,0,36,48V208a12.01343,12.01343,0,0,0,12,12H208a12.01343,12.01343,0,0,0,12-12V48A12.01343,12.01343,0,0,0,208,36ZM48,44H76V56a4,4,0,0,0,8,0V44h88V56a4,4,0,0,0,8,0V44h28a4.00427,4.00427,0,0,1,4,4V84H44V48A4.00427,4.00427,0,0,1,48,44ZM208,212H48a4.00427,4.00427,0,0,1-4-4V92H212V208A4.00427,4.00427,0,0,1,208,212Zm-84-48.00293a19.99994,19.99994,0,0,1-34.13379,14.15039A4.00009,4.00009,0,0,1,95.52,172.4873,11.9999,11.9999,0,1,0,104,151.99707a4.00011,4.00011,0,0,1-3.12354-6.499l10.80127-13.501H92a4,4,0,1,1,0-8h28a4.00011,4.00011,0,0,1,3.12354,6.499l-11.88526,14.85645A20.03329,20.03329,0,0,1,124,163.99707Zm40-36v52a4,4,0,0,1-8,0v-44l-9.6001,7.2002a4.0001,4.0001,0,1,1-4.7998-6.40039l16-12A3.99971,3.99971,0,0,1,164,127.99707Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.49fa2715f671a814cdd5ca500fa6829c.svg";
export { ForwardRef as ReactComponent };